import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, HostListener } from '@angular/core';

// trustpilot.d.ts
interface Window {
  Trustpilot: {
    loadFromElement: (element: HTMLElement) => void;
    // Add other Trustpilot properties and methods as needed
  };
}

@Component({
  selector: 'app-trust-pilot',
  templateUrl: './trust-pilot.component.html',
  styleUrls: ['./trust-pilot.component.scss']
})




export class TrustPilotComponent implements OnInit {
  isMobile = false;
  constructor(@Inject(PLATFORM_ID) private platformId) {}

  ngOnInit(): void {
    // Call the function to load Trustpilot when the component initializes
    if (isPlatformBrowser(this.platformId)) {
      this.updateIsMobile();
      this.loadTrustpilot();
    }
  }

  updateIsMobile(): void {
    this.isMobile = (window.innerWidth || 0) <= 768;
  }

  @HostListener('window:resize')
  onResize(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const prev = this.isMobile;
    this.updateIsMobile();
    if (prev !== this.isMobile) {
      this.loadTrustpilot();
    }
  }

  loadTrustpilot(): void {
    // Use a type assertion to access Trustpilot
    const trustpilot = (window as any).Trustpilot;

    if (trustpilot) {
      // Check if Trustpilot is available
      const trustboxRef = document.getElementById('trustbox');
      if (trustboxRef) {
        // Get the reference to the trustbox element by its id
        trustpilot.loadFromElement(trustboxRef);
      } else {
        console.error("Trustbox element not found.");
      }
    } else {
      console.error("Trustpilot not found on the window object.");
    }
  }
}